import { Link, useParams } from "react-router-dom"
import { useGetToolProfileQuery } from "../features/model/toolprofileSlice";
import Loading from "../components/Loading";
import { Button, ButtonGroup, Stack } from "@mui/material";
const ToolProfileView = () => {
  let params = useParams();
  console.log(params.objectId)
  const {data: object, error, isLoading} = useGetToolProfileQuery(params.objectId)
  console.log("tool profile view")

  if (isLoading) {
    return <Loading />;
  }
  return <Stack sx={{marginTop: 2, marginBottom: 4}} spacing={2}>
    <ButtonGroup>
      <Button component={Link} to={`/toolprofiles/`}>Back</Button>
      <Button variant="contained" component={Link} to={`/toolprofiles/${params.objectId}/edit`}>Edit</Button>
    </ButtonGroup>
  </Stack>
}

export default ToolProfileView;